import { cardsItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-300 border border-secondary-500/20 mb-4">
            编辑推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            精选内容
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            编辑团队精心挑选的优质内容，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsItems.slice(0, 6).map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent" />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-[11px] font-medium rounded bg-accent-500/80 text-foreground-50 whitespace-nowrap backdrop-blur-sm">
                  {item.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}

          <article className="rounded-xl overflow-hidden bg-gradient-to-br from-primary-500/10 to-accent-500/10 border border-primary-500/20 flex flex-col items-center justify-center p-8 text-center cursor-pointer hover:border-primary-500/40 transition-all duration-300">
            <div className="w-16 h-16 rounded-full bg-primary-500/20 flex items-center justify-center mb-4">
              <i className="ri-arrow-right-line text-2xl text-primary-400"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-100 mb-2">
              {cardsItems[6].title}
            </h3>
            <p className="text-sm text-foreground-400 mb-4">
              {cardsItems[6].desc}
            </p>
            <span className="inline-flex items-center gap-1.5 text-sm text-primary-400 font-medium">
              立即查看
              <i className="ri-arrow-right-line"></i>
            </span>
          </article>
        </div>
      </div>
    </section>
  );
}